import { FC } from "react";
import ChatFragment from "../../containers/fragments/ChatFragment";
import EmailFragment from "../../containers/fragments/EmailFragment";
import VoiceConversation from "../voice/VoiceConversationWindow";
import { IWorkItem } from "../../../models/BlenderAgentStateModel";

interface IProps {
  workItem: IWorkItem;
}

const ConversationPanelRenderer: FC<IProps> = ({ workItem }) => {
  switch (workItem.primaryMediaType) {
    case "Webchat":
    case "Messaging":
      return <ChatFragment workItem={workItem} />;
    case "Email":
      return <EmailFragment workItem={workItem} />;
    case "Voice":
      return <VoiceConversation workItem={workItem} />;
    default:
      return <div>Unknown</div>;
  }
};

export default ConversationPanelRenderer;
